<script lang="ts">
    import CN from "classnames";

    import Button from "@components/Buttons/Button.svelte";
    import Icon from "@components/Icon.svelte";
    import GrowaveBrandIcon from "@components/icons/GrowaveBrandIcon.svelte";
    import Text from "@components/Typography/Text.svelte";

    //Props
    export let canShowWatermark: boolean | undefined;

    //Optional Props
    export let className: string;
    export { className as class };

    const growaveBrandLink =
        "https://www.growave.io/?utm_source=powered+by&utm_medium=growave&utm_campaign=shop";
</script>

{#if canShowWatermark}
    <div class={CN("gw-brand", className)}>
        <Button
            variant="link"
            target="_blank"
            url={growaveBrandLink}
            rel="noopener noreferrer"
            ariaLabel="Opens the Growave website in a new tab"
        >
            <Text component="span" variant="base">Powered by</Text>
            <Icon width="68" height="14" viewBox="0 0 68 14">
                <GrowaveBrandIcon />
            </Icon>
        </Button>
    </div>
{/if}

<style lang="postcss">
    .gw-brand {
        width: 100%;
        font-size: 12px;
        line-height: 15px;
        color: hsl(0, 0%, 75%);

        :global(.gw-btn.gw-button.--link) {
            text-decoration: none;
            overflow: visible;
        }

        :global(.gw-layout-text) {
            padding-top: var(--gw-space-2);
        }
    }
</style>
